export const todayIso = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export const yesterdayIso = () => {
  const d = new Date(); d.setDate(d.getDate() - 1)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export const monthStartIso = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`
}

export const monthEndIso = () => {
  const d = new Date()
  const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`
}

export const quarterStartIso = () => {
  const d = new Date()
  const q = Math.floor(d.getMonth() / 3)
  return `${d.getFullYear()}-${String(q * 3 + 1).padStart(2, '0')}-01`
}

export const quarterEndIso = () => {
  const d = new Date()
  const q = Math.floor(d.getMonth() / 3)
  const lastMonth = q * 3 + 2
  const lastDay = new Date(d.getFullYear(), lastMonth + 1, 0).getDate()
  return `${d.getFullYear()}-${String(lastMonth + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`
}
